var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-refresh-of-table"},[_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.data))]),_vm._v(" "),_c('Button',{attrs:{"shape":"circle","icon":"icon-pg-serach","loading":_vm.loading,"title":_vm.examineIconTitle},on:{"click":_vm.getData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }